import React from 'react'
import UserListDataTable from '../../components/Admin/UserList';

const UserList = () => {
  return (
    <UserListDataTable />
  )
}

export default UserList;